import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { User } from "services/api";

interface AuthState {
  token: string;
  user?: User;
}

const initialState: AuthState = {
  token: localStorage.getItem("token"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSucceeded(
      state,
      action: PayloadAction<{ token: string; user: User }>
    ) {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    setUserInfo(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    logout(state) {
      state.token = "";
      state.user = undefined;
    },
  },
});

export const { loginSucceeded, setUserInfo, logout } = authSlice.actions;

export default authSlice.reducer;
